const RefreshIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 3C5.86417 3 2.5 6.365 2.5 10.5H4.16667C4.16667 7.28333 6.78417 4.66667 10 4.66667C11.8209 4.66667 13.4377 5.514 14.5068 6.8265L12.5 8.83334H17.5V3.83333L15.695 5.63835C14.3207 4.02639 12.2804 3 10 3ZM15.8333 10.5C15.8333 13.7158 13.2158 16.3333 10 16.3333C8.17909 16.3333 6.56233 15.486 5.49317 14.1735L7.5 12.1667H2.5V17.1667L4.30502 15.3617C5.6793 16.9736 7.71963 18 10 18C14.1358 18 17.5 14.6358 17.5 10.5H15.8333Z"
        fill="#0D0C21"
      />
    </svg>
  );
};

export default RefreshIcon;
